import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/index/index'
import Cashier from '../components/cashier/index'
import Regist from '../components/regist/index'
import Return from '../components/return/index'
import Result from '../components/result/index'
import {PullRefresh} from 'vant';

Vue.use(VueRouter)
Vue.use(PullRefresh);

const routes = [
    // 首页
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    // 收银台
    {
        path: '/cashier',
        name: 'cashier',
        component: Cashier
    },
    //退号
    {
        path: '/regist',
        name: 'regist',
        component: Regist
    },
    //退款
    {
        path: '/return',
        name: 'return',
        component: Return
    },
     // 结果
     {
        path: '/result',
        name: 'result',
        component: Result
    },
]

const router = new VueRouter({
    mode: 'history',
    base: '/yy/',
    routes
})

export default router
